module.exports = __webpack_public_path__ + "static/media/wingate_collection05_19_0886.e401e3a4.jpg";